import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=080534d5&scoped=true&"
import script from "./TableOfContents.vue?vue&type=script&lang=js&"
export * from "./TableOfContents.vue?vue&type=script&lang=js&"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=080534d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080534d5",
  null
  
)

export default component.exports